import React, { useState,useEffect } from 'react';
import Select from 'react-select';
import { allUsersSelect } from 'network/ApiAxios';

function SearchSelectAllUsers(props) {
    useEffect(() => {
        getUsers()
    }, []);

    const [selectedOption, setSelectedOption] = useState(null);
    const [options, setOptions] = useState();

    const getUsers = async()=>{
        const resp = await allUsersSelect()
        if (resp.data.success){
            setOptions(resp.data.users)
        }
    }

    return (
      <div className="mb-2">
        <Select
          defaultValue={selectedOption}
          onChange={props.onSelect}
          options={options}
          isSearchable={true}
        />
      </div>
    )
}

export default SearchSelectAllUsers